import { client } from '@generated/admin-prime/client.gen';
import { getAuthToken } from '@auth/session-storage';
import { config } from '@config';

export const ADMIN_PRIME_URL = config.adminPrimeUrl;

client.setConfig({
    baseUrl: ADMIN_PRIME_URL,
    auth: () => getAuthToken() ?? '',
});

export { client as adminPrimeClient };
